import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const UnId = styled.div`
    width: 33px;
    height: 21px;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: 0px;
    color: #4f4f4f;
`;

export const Status = styled.div`
    display: flex;
    /* width: 97px; */
    height: 21px;
    text-align: left;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: 0px;
    color: #140f4b;
    opacity: 1;
    text-overflow: ${({ textOverflow }) => textOverflow};
    overflow: ${({ overflow }) => overflow};
`;

export const UnIdConainter = styled.div`
    display: flex;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : 'auto')};

    /* margin-right: 50px;
    margin-top: 10px; */
    ${media.mobileDevice`
    text-align:left;
   `}
`;

export const UnIdNumber = styled.div`
    width: auto;
    margin-right: 5px;
    height: ${(props) => props.height};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    letter-spacing: 0px;
    color: ${({ color }) => (color ? color : '#1010eb')};
    margin-left: 5px;
    cursor: ${({ cursor }) => cursor};
    text-overflow: ${({ textOverflow }) => textOverflow};
    overflow: ${({ overflow }) => overflow};
`;

export const NormalDiv = styled.div`
    height: ${(props) => props.height};
    display: flex;
    align-items: center;
    padding: 0;
    margin: ${({ margin }) => (margin ? margin : 0)};
`;

export const DemiText = styled.div`
    color: ${(props) => (props.color ? props.color : '#585858')};
    font-size: ${(props) => props.fontSize};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: AvenirNextWorld Demi;
    margin: ${({ margin }) => (margin ? margin : 0)};
    cursor: ${({ cursor }) => cursor};
`;

export const RegularText = styled.div`
    color: ${(props) => (props.color ? props.color : '#585858')};
    font-size: ${(props) => props.fontSize};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    margin: ${({ margin }) => (margin ? margin : 0)};
`;

export const EmptyDiv = styled.div`
    height: ${(props) => (props.height ? props.height : '21px')};
`;
